import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-plane-line',
      title: t('service1Title'),
      description: t('service1Desc'),
      keywords: t('service1Keywords')
    },
    {
      icon: 'ri-map-pin-user-line',
      title: t('service2Title'),
      description: t('service2Desc'),
      keywords: t('service2Keywords')
    },
    {
      icon: 'ri-time-line',
      title: t('service3Title'),
      description: t('service3Desc'),
      keywords: t('service3Keywords')
    },
    {
      icon: 'ri-shield-check-line',
      title: t('service4Title'),
      description: t('service4Desc'),
      keywords: t('service4Keywords')
    },
    {
      icon: 'ri-price-tag-3-line',
      title: t('service5Title'),
      description: t('service5Desc'),
      keywords: t('service5Keywords')
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('service6Title'),
      description: t('service6Desc'),
      keywords: t('service6Keywords')
    },
  ];

  return (
    <section id="servicos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-4">
            <i className="ri-service-line text-3xl text-orange-500"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            <strong>{t('servicesMainTitle')}</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('servicesMainSubtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <article 
              key={index}
              className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-orange-100"
            >
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6 shadow-lg">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                <strong>{service.title}</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {service.description}
              </p>
              <div className="text-xs text-gray-400 italic">
                {service.keywords}
              </div>
            </article>
          ))}
        </div>

        {/* Additional SEO Content */}
        <div className="mt-16 bg-gradient-to-r from-orange-50 to-orange-100 rounded-2xl p-8 border border-orange-200">
          <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
            <strong>{t('whyChooseFarways')}</strong>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-700">
            <div className="flex items-start space-x-3">
              <i className="ri-checkbox-circle-fill text-green-600 text-2xl mt-1"></i>
              <div>
                <strong className="block mb-1">{t('whyReason1Title')}</strong>
                <p className="text-sm">{t('whyReason1Desc')}</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-checkbox-circle-fill text-green-600 text-2xl mt-1"></i>
              <div>
                <strong className="block mb-1">{t('whyReason2Title')}</strong>
                <p className="text-sm">{t('whyReason2Desc')}</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-checkbox-circle-fill text-green-600 text-2xl mt-1"></i>
              <div>
                <strong className="block mb-1">{t('whyReason3Title')}</strong>
                <p className="text-sm">{t('whyReason3Desc')}</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-checkbox-circle-fill text-green-600 text-2xl mt-1"></i>
              <div>
                <strong className="block mb-1">{t('whyReason4Title')}</strong>
                <p className="text-sm">{t('whyReason4Desc')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
